import StickySidebar from "sticky-sidebar";
const sidebars = document.querySelectorAll('.sidebar');

if(sidebars.length > 0) {
    scrollStickySidebar();

    window.addEventListener('scroll', function() {
        scrollStickySidebar();
    }, false);
}

function scrollStickySidebar() {
    const mediaBreakPoint = '(max-width: 768px)';
    const mq = window.matchMedia(mediaBreakPoint);
    const scrollPosY = window.pageYOffset || document.documentElement.scrollTop;
    const windowWidth = window.innerWidth;

    const removeScrolling = function (mq) {
        // Note: Only activate the sticky-sidebar.js library when user start scrolling (scrollPosY > 1),
        // because if we don't do this, it will get the original thicker header's height as its trigger value
        // instead of the thinner header's height.
        if (!mq.matches && scrollPosY > 1) {
            let topSpaceValue = 0;

            if(windowWidth > 1024) {
                topSpaceValue = 130;
            } else {
                topSpaceValue = 100;
            }

            for (let i = 0; i < sidebars.length; i++) {
                new StickySidebar(sidebars[i], {
                    topSpacing: topSpaceValue,
                    bottomSpacing: 20,
                    containerSelector: ".main-content",
                    innerWrapperSelector: ".sidebar__inner"
                });
            }
        }
    }

    mq.addListener(removeScrolling);
    removeScrolling(mq);
}